import { COOKIE_PREFERENCES_TRIGGER_ID } from "@/app/config/cookie-consent";

export const PATHS_WITHOUT_COOKIE_CONSENT = [
	"/cms",
	"/linktree",
	"/spec-hiace",
	"/TPHiace",
	"/touchpoint",
	"/touch-point",
	"/agrobrasilia-2026",
	"/lp-yaris-cross",
	"/lp-yaris-cross-360",
	"/move-brasil",
	"/stock-car-brasilia",
	"/indique-amigo",
	"/programa-indicacao",
	"/ofertas",
] as const;

export function isPathWithoutCookieConsent(path: string): boolean {
	const normalized = path.split("?")[0] || "/";
	return PATHS_WITHOUT_COOKIE_CONSENT.some(
		(prefix) =>
			normalized === prefix || normalized.startsWith(`${prefix}/`),
	);
}

type CookieConsentApi = {
	showPreferences?: () => void;
	show?: (modal?: string) => void;
};

function getCookieConsentApi(): CookieConsentApi | undefined {
	if (typeof window === "undefined") return undefined;
	return (window as Window & { CookieConsent?: CookieConsentApi })
		.CookieConsent;
}

/** Abre o modal BeCompliance “Quem pode usar seus cookies?”. */
export function showCookiePreferencesModal() {
	const cc = getCookieConsentApi();
	if (cc?.showPreferences) {
		cc.showPreferences();
		return;
	}
	if (typeof cc?.show === "function") {
		cc.show("preferencesModal");
		return;
	}

	const trigger = document.getElementById(COOKIE_PREFERENCES_TRIGGER_ID);
	trigger?.click();
}
